// extracted by mini-css-extract-plugin
export default {"formContainer":"jBJ5xoLPTghzOv4cRARE"};